import { createAction, props } from '@ngrx/store';
import { RestApiError } from 'src/app/common-components/errors/models/error-message';

export const saveExpandMenu = createAction('[User Preferences] Save Menu Expanded', props<{ expandMenu: boolean }>());
export const saveExpandMenuSuccess = createAction('[API] Save Menu Expanded Success', props<{ expandMenu: boolean }>());
export const saveExpandMenuFailure = createAction('[API] Save Menu Expanded Failure', props<RestApiError>());
export const saveSelectedDashboardId = createAction(
   '[User Preferences] Save Selected Dashboard Id',
   props<{ selectedDashboardId: number | null }>()
);
export const saveSelectedDashboardIdSuccess = createAction(
   '[API] Save Selected Dashboard Id Success',
   props<{ selectedDashboardId: number | null }>()
);
export const saveSelectedDashboardIdFailure = createAction(
   '[API] Save Selected Dashboard Id Failure',
   props<RestApiError>()
);
export const saveMostRecentDeviceType = createAction(
   '[User Preferences] Save Most Recent Device Type',
   props<{ mostRecentDeviceType: string | null }>()
);
export const saveMostRecentDeviceTypeSuccess = createAction(
   '[API] Save Most Recent Device Type Success',
   props<{ mostRecentDeviceType: string | null }>()
);
export const saveMostRecentDeviceTypeFailure = createAction(
   '[API] Save Most Recent Device Type Failure',
   props<RestApiError>()
);
export const saveShowExtensionRegisterPopup = createAction(
   '[User Preferences] Save Extension Register Tooltip Preference',
   props<{ showExtensionRegisterPopup: boolean | null }>()
);
export const saveShowExtensionRegisterPopupSuccess = createAction(
   '[API] Save Extension Register Tooltip Preference Success',
   props<{ showExtensionRegisterPopup: boolean | null }>()
);
export const saveShowExtensionRegisterPopupFailure = createAction(
   '[API] Save Extension Register Tooltip Preference Failure',
   props<RestApiError>()
);
export const saveQueueHistoryRegisterWrapQueues = createAction(
   '[User Preferences] Save Queue History Register Wrap Queues',
   props<{ queueHistoryRegisterWrapQueues: boolean }>()
);
export const saveQueueHistoryRegisterWrapQueuesSuccess = createAction(
   '[API] Save Queue History Register Wrap Queues Success',
   props<{ queueHistoryRegisterWrapQueues: boolean }>()
);
export const saveQueueHistoryRegisterWrapQueuesFailure = createAction(
   '[API] Save Queue History Register Wrap Queues Failure',
   props<RestApiError>()
);
export const saveExpandCallDetailAdvancedSection = createAction(
   '[User Preferences] Save Call Detail Advanced Section Expanded',
   props<{ expandCallDetailAdvancedSection: boolean }>()
);
export const saveExpandCallDetailAdvancedSectionSuccess = createAction(
   '[API] Save Call Detail Advanced Section Expanded Success',
   props<{ expandCallDetailAdvancedSection: boolean }>()
);
export const saveExpandCallDetailAdvancedSectionFailure = createAction(
   '[API] Save Call Detail Advanced Section Expanded Failure',
   props<RestApiError>()
);
